"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Input = _interopRequireDefault(require("./Input"));

var _InputContainer = _interopRequireDefault(require("./InputContainer"));

var _Label = _interopRequireDefault(require("../Label"));

var _Constant = require("../../Constant");

var _util = require("../../Util/util");

var _VisuallyHidden = _interopRequireDefault(require("../../VisuallyHidden"));

var _Typeahead = require("./Typeahead");

var _Input2 = require("../../Dashboard/Input/Input");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  input {\n    ", "\n    ", "\n    margin-top: ", ";\n    border: ", ";\n\n    &:hover:not([disabled]) {\n      border-color: ", ";\n    }\n\n    &:focus {\n      outline: ", ";\n      outline-offset: ", ";\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  padding-left: 5px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Strong = _styledComponents.default.strong(_templateObject(), _Constant.Color.BLACK);

var Small = _styledComponents.default.small(_templateObject2(), _Constant.Color.DARK_GREY); // NumberFormat automatically proxies unknown props as html attributes so will warn if passed errorText directly.


var Wrapper = (0, _styledComponents.default)(_InputContainer.default).attrs(function (_ref) {
  var errorText = _ref.errorText,
      useDashboardStyles = _ref.useDashboardStyles;
  return {
    'data-error': errorText && errorText.length > 0
  };
})(_templateObject3(), function (props) {
  return props.useDashboardStyles && _Input2.inputStyles;
}, function (props) {
  return props.useDashboardStyles && _Input2.dashboardStyles;
}, function (props) {
  return props.useDashboardStyles && '8px';
}, function (props) {
  return props.useDashboardStyles && "1px solid ".concat(props['data-error'] ? _Constant.Color.ERROR : _Constant.Color.GREY_4);
}, function (props) {
  return props.useDashboardStyles && _Constant.Color.FOCUS_B;
}, function (props) {
  return props.useDashboardStyles && "4px solid ".concat(_Constant.Color.FOCUS_B);
}, function (props) {
  return props.useDashboardStyles && "0";
});

var AddressInput = function AddressInput(_ref2) {
  var id = _ref2.id,
      label = _ref2.label,
      errorText = _ref2.errorText,
      value = _ref2.value,
      onChange = _ref2.onChange,
      debounce = _ref2.debounce,
      onAutocompleteSelection = _ref2.onAutocompleteSelection,
      cancelable = _ref2.cancelable,
      isHiddenLabel = _ref2.isHiddenLabel,
      descriptiveTextId = _ref2.descriptiveTextId,
      asterisks = _ref2.asterisks,
      useDashboardStyles = _ref2.useDashboardStyles,
      fsMask = _ref2.fsMask,
      otherProps = (0, _objectWithoutProperties2.default)(_ref2, ["id", "label", "errorText", "value", "onChange", "debounce", "onAutocompleteSelection", "cancelable", "isHiddenLabel", "descriptiveTextId", "asterisks", "useDashboardStyles", "fsMask"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      selection = _useState4[0],
      setSelection = _useState4[1];

  var _ref3 = selection || {},
      street1 = _ref3.street1;

  var onFocus = function onFocus(e) {
    return setFocused(e.type === 'focus');
  };

  var selectOption = function selectOption(value) {
    setSelection(value);
    onAutocompleteSelection(value);
  };

  return /*#__PURE__*/_react.default.createElement(_Typeahead.TypeaheadContainer, {
    cancelable: cancelable,
    debounce: debounce,
    disabled: !focused || street1 === value,
    id: id,
    onAutocompleteSelection: onAutocompleteSelection,
    onChange: onChange,
    onFocus: onFocus,
    selectOption: selectOption,
    setSelection: setSelection,
    value: value,
    url: "https://".concat(_util.isProd ? '' : 'test.', "figure.com/address-lookup?partialAddress=")
  }, function (childrenProps) {
    var hideMenu = childrenProps.hideMenu,
        highlightedIndex = childrenProps.highlightedIndex,
        inputProps = childrenProps.inputProps,
        labelId = childrenProps.labelId,
        menuId = childrenProps.menuId,
        results = childrenProps.results,
        statusMessage = childrenProps.statusMessage;
    return /*#__PURE__*/_react.default.createElement(Wrapper, {
      errorText: errorText,
      useDashboardStyles: useDashboardStyles
    }, /*#__PURE__*/_react.default.createElement(_Label.default, {
      htmlFor: id,
      errorText: errorText,
      id: labelId,
      isVisuallyHidden: isHiddenLabel,
      asterisks: asterisks
    }, label), /*#__PURE__*/_react.default.createElement(_Input.default, (0, _extends2.default)({
      fsMask: fsMask,
      errorText: errorText,
      "aria-invalid": errorText ? 'true' : null,
      "aria-describedby": descriptiveTextId
    }, otherProps, inputProps)), results.length > 0 && /*#__PURE__*/_react.default.createElement(_Typeahead.Typeahead, {
      results: results,
      id: menuId,
      fsMask: fsMask,
      handleSelect: function handleSelect(address) {
        selectOption(address);
        hideMenu();
      },
      highlightedIndex: highlightedIndex,
      labelledBy: labelId,
      renderRow: function renderRow(address) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Strong, null, address.street1, " ", address.street2), /*#__PURE__*/_react.default.createElement(Small, null, address.city, ", ", address.state, ", ", address.zip));
      }
    }), /*#__PURE__*/_react.default.createElement(_VisuallyHidden.default, {
      as: "div",
      "aria-live": "polite",
      role: "status"
    }, /*#__PURE__*/_react.default.createElement("p", null, statusMessage)));
  });
};

AddressInput.propTypes = {
  /** The id of the input */
  id: _propTypes.default.string.isRequired,

  /** The Label used for the input */
  label: _propTypes.default.string.isRequired,

  /** Used to control the input */
  value: _propTypes.default.string,

  /** Used for validation */
  errorText: _propTypes.default.string,

  /** Used to update the value */
  onChange: _propTypes.default.func.isRequired,

  /** Callback function to run when a selection is made on the autocomplete */
  onAutocompleteSelection: _propTypes.default.func.isRequired,

  /** Length of the debounce for the autocomplete */
  debounce: _propTypes.default.number,

  /** If typeahead rows are cancelable */
  cancelable: _propTypes.default.bool,

  /** Ideally, label text is always visible.
   * If necessary, this prop will hide label text from sighted users while still making it available to assistive technology.
   * It will not hide error text.
   */
  isHiddenLabel: _propTypes.default.bool,

  /**
   * Links input helper text or footnote text to the input for assistive technology users.
   * Accepts either the id or multiple space-separated ids of the text you want to link to.
   */
  descriptiveTextId: _propTypes.default.string,

  /** The number of asterisks to render in the label */
  asterisks: _propTypes.default.number,

  /** Use Dashboard input styles */
  useDashboardStyles: _propTypes.default.bool,

  /** Toggles masking input within FullStory */
  fsMask: _propTypes.default.bool
};
AddressInput.defaultProps = {
  value: '',
  errorText: '',
  debounce: 100,
  cancelable: false,
  isHiddenLabel: false,
  descriptiveTextId: null,
  asterisks: null,
  useDashboardStyles: false,
  fsMask: true
};
var _default = AddressInput;
exports.default = _default;